module.exports = __webpack_public_path__ + "img/43.78c2fb84.png";